export default __webpack_public_path__ + "static/media/productHealthCheckPackage2_all_Hk.b4329e88.webp";